import React from 'react'

import Heading from '../Heading/Heading'
import * as Styled from './styles'

export interface Props {
  title?: string
  htmlMessage: string
  callToAction?: {
    text: string
    onClick: () => void
    direction?: 'back' | 'forward'
  }
}

const AlertBox: React.FC<Props> = ({ title, htmlMessage, callToAction }) => {
  return (
    <Styled.AlertBox>
      <i className="fas fa-exclamation" aria-hidden="true" />
      {Boolean(title) && (
        <Heading level={3} className="alert-box-title">
          {title}
        </Heading>
      )}
      <div className="alert-box-message" dangerouslySetInnerHTML={{ __html: htmlMessage }} />
      {Boolean(callToAction?.text && callToAction?.onClick) && (
        <button className="alert-box-cta" onClick={callToAction?.onClick}>
          {callToAction?.direction === 'back' && <i className="fas fa-arrow-left" aria-hidden="true" />}
          {callToAction?.text}
          {callToAction?.direction === 'forward' && <i className="fas fa-chevron-right" aria-hidden="true" />}
        </button>
      )}
    </Styled.AlertBox>
  )
}

export default AlertBox
